export var getRootAndChildNodes = function (nodes) {
    var rootNodes = [];
    var childNodes = [];
    var nodesAreChildren = {};
    nodes.forEach(function (node) {
        (node.children || []).forEach(function (child) {
            nodesAreChildren[child] = true;
        });
        if (!nodesAreChildren[node.id]) {
            nodesAreChildren[node.id] = false;
        }
    });
    nodes.forEach(function (node) {
        if (nodesAreChildren[node.id]) {
            childNodes.push(node);
        }
        else {
            rootNodes.push(node);
        }
    });
    return { rootNodes: rootNodes, childNodes: childNodes };
};
